import { render, staticRenderFns } from "./FactureDetail.vue?vue&type=template&id=4808a912&scoped=true&"
import script from "./FactureDetail.vue?vue&type=script&lang=js&"
export * from "./FactureDetail.vue?vue&type=script&lang=js&"
import style0 from "./FactureDetail.vue?vue&type=style&index=0&id=4808a912&lang=scss&scoped=true&"
import style1 from "./FactureDetail.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./FactureDetail.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4808a912",
  null
  
)

export default component.exports